// import axiosInstance from "../axiosInstance";

// export const GETCodigoBarra = async (codigo, idOpe) => {
//   try {
//     let url = `${process.env.REACT_APP_WMS_BASE_URL}/codigo-barra/${encodeURIComponent(codigo)}`;

//     // Agregar el parámetro idauditoria solo si idOpe es válido (no null, undefined, ni cadena vacía)
//     if (idOpe != null && idOpe !== "") {
//       const params = new URLSearchParams({ idauditoria: idOpe });
//       url += `?${params.toString()}`;
//     }

//     const response = await axiosInstance.get(url, {
//       headers: {
//         "Content-Type": "application/json",
//       },
//     });

//     return {
//       status: response.status,
//       data: response.data,
//     };
//   } catch (error) {
//     return {
//       status: error.response?.status,
//       data: error.response?.data,
//       message:
//         error.response?.data?.message || "Error al realizar la solicitud",
//     };
//   }
// };

// export default GETCodigoBarra;

import axiosInstance from "../axiosInstance";

export const GETCodigoBarra = async (codigo, idOpe, param2, param3) => {
  try {
    let url = `${process.env.REACT_APP_WMS_BASE_URL}/codigo-barra/${encodeURIComponent(codigo)}`;

    // Creamos los parámetros query solo si existen
    const params = new URLSearchParams();

    if (idOpe != null && idOpe !== "") {
      params.append("idauditoria", idOpe);
    }

    if (param2 != null) {
      params.append("param2", param2); // será true/false
    }

    if (param3 != null) {
      params.append("param3", param3); // será true/false
    }

    // Si hay parámetros, agregarlos a la URL
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    const response = await axiosInstance.get(url, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return {
      status: response.status,
      data: response.data,
    };
  } catch (error) {
    return {
      status: error.response?.status,
      data: error.response?.data,
      message:
        error.response?.data?.message || "Error al realizar la solicitud",
    };
  }
};

export default GETCodigoBarra;
